import React from 'react';
import { HeroSection } from '../components/sections/HeroSection';
import { TrustStrip } from '../components/sections/TrustStrip';
import { ServicesSection } from '../components/sections/ServicesSection';
import { WhyUsSection } from '../components/sections/WhyUsSection';
import { AfricanPresenceSection } from '../components/sections/AfricanPresenceSection';
import { WorkPreviewSection } from '../components/sections/WorkPreviewSection';
import { ProcessSection } from '../components/sections/ProcessSection';
import { TestimonialsSection } from '../components/sections/TestimonialsSection';
import { BlogPreviewSection } from '../components/sections/BlogPreviewSection';
import { CTASection } from '../components/sections/CTASection';
export function HomePage() {
  return <main data-id="element-1311">
      <HeroSection data-id="element-1312" />
      <ServicesSection data-id="element-1313" />
      <WhyUsSection data-id="element-1314" />
      <AfricanPresenceSection data-id="element-1315" />
      <WorkPreviewSection data-id="element-1316" />
      <ProcessSection data-id="element-1317" />
      <TestimonialsSection data-id="element-1318" />
      <CTASection data-id="element-1319" />
      <BlogPreviewSection data-id="element-1320" />
      <TrustStrip data-id="element-1321" />
    </main>;
}